import React from "react";

import { faChevronUp } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import styles from "./ViewEvent.module.css";

export default function CollapseButton({ collapseClicked }: { collapseClicked: () => void }) {
	return (
		<div className={cx(styles.infoRow, styles.expandButton)} onClick={collapseClicked}>
			<div className={cx(styles.infoRow__icon, styles.centered)}>
				<FontAwesomeIcon fixedWidth icon={faChevronUp} />
			</div>
			<div className={styles.infoRow__text}>Show less</div>
		</div>
	);
}
